export type EmployeeEmploymentStatus = 'ACTIVE' | 'INACTIVE'
export type PermissionResourceType = 'MENU' | 'BUTTON' | 'API'

export interface SystemRoleBrief {
  id: number
  roleCode: string
  roleName: string
}

export interface SystemPermissionBrief {
  id: number
  permissionCode: string
  permissionName: string
}

export interface SystemEmployee {
  id: number
  employeeNo: string
  employeeName: string
  positionTitle: string
  employmentStatus: EmployeeEmploymentStatus
  loginMobile?: string | null
  miniProgramUid?: string | null
  roles: SystemRoleBrief[]
  createdAt: string
  updatedAt: string
}

export interface SystemRole {
  id: number
  roleCode: string
  roleName: string
  description?: string | null
  enabled: boolean
  builtIn: boolean
  employeeCount: number
  permissions: SystemPermissionBrief[]
  createdAt: string
  updatedAt: string
}

export interface SystemPermission {
  id: number
  permissionCode: string
  permissionName: string
  resourceType: PermissionResourceType
  resourcePath?: string | null
  httpMethod?: string | null
  description?: string | null
  enabled: boolean
  sortOrder: number
  roleCount: number
  createdAt: string
  updatedAt: string
}

export interface UpsertSystemEmployeeRequest {
  employeeNo: string
  employeeName: string
  positionTitle: string
  employmentStatus: EmployeeEmploymentStatus
  loginMobile?: string
  miniProgramUid?: string
}

export interface UpsertSystemRoleRequest {
  roleCode: string
  roleName: string
  description?: string
  enabled: boolean
}

export interface UpsertSystemPermissionRequest {
  permissionCode: string
  permissionName: string
  resourceType: PermissionResourceType
  resourcePath?: string
  httpMethod?: string
  description?: string
  enabled: boolean
  sortOrder?: number
}

export const EMPLOYMENT_STATUS_LABELS: Record<EmployeeEmploymentStatus, string> = {
  ACTIVE: '在职',
  INACTIVE: '离职 / 停用',
}

export const PERMISSION_RESOURCE_TYPE_LABELS: Record<PermissionResourceType, string> = {
  MENU: '菜单',
  BUTTON: '按钮',
  API: '接口',
}
